export default "__VITE_ASSET__b11ce67d__"